<template>
  <div class="inquiry_list">
    <!-- tab -->
    <div class="title_row">
      <div class="tabs" style="margin:0 25px;font-size:16px;">
        <div v-for="item in inquiryStatusList"
            :key="item.key"
            :class="'inquiry-tab-item '+(item.key===dataForm.status?'tab-item-active':'')"
            @click="changeStatusHandle(item.key)">
          {{item.lable}}
        </div>
      </div>
      <div>
        <el-button class="butt" type="primary" @click="addHandle()">新增</el-button>
        <el-button class="butt"
                  type="primary"
                  icon="el-icon-time"
                  @click="urgeHandle()"
                  v-show="dataForm.status === '10'"
                  v-if="$hasPermission('front:inquiry:urge')">催促受理</el-button>
      </div>
    </div>
    <!--  -->
    <el-form :inline="true" :model="dataForm" v-show="dataForm.status !== '19'">
      <el-form-item label="单据编号：">
        <el-input v-model.trim="dataForm.inquiryNo" placeholder="单据编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="制单时间：">
        <el-date-picker type="datetime" placeholder="选择日期" v-model="dataForm.startTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:200px;display:inline-block"></el-date-picker>
        <span style="text-align:center;display:inline-block">-</span>
        <el-date-picker type="datetime" placeholder="选择时间" v-model="dataForm.endTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:200px;display:inline-block"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="butt" type="primary" @click="getDataList(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      key="inquiryTable"
      v-loading="dataLoading"
      v-show="dataForm.status !== '19'"
      border>
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无相关询价单">
        <div>暂无相关询价单</div>
      </div>
      <el-table-column type="index" header-align="center" align="center" width="50"></el-table-column>
      <!-- <el-table-column prop="id" header-align="center" align="center" label="id"></el-table-column> -->
      <el-table-column prop="inquiryNo" header-align="center" align="center" label="询价单编号"></el-table-column>
      <el-table-column prop="status" header-align="center" align="center" label="状态" width="100px">
        <template slot-scope="scope">
          {{$getDictLabel('INQUIRY_STATUS', scope.row.status)}}
          <!-- <el-tag size="mini" color="#67c23a" v-if="scope.row.status === 17">已报价</el-tag>
          <el-tag size="mini" color="#2d8cf0" v-else-if="scope.row.status === 13">报价中</el-tag>
          <el-tag size="mini" color="#2d8cf0" v-else-if="scope.row.status === 15">报价中</el-tag>
          <el-tag size="mini" color="#67c23a" v-else-if="scope.row.status === 19">已生成订单</el-tag>
          <el-tag size="mini" color="#f56c6c" v-else-if="scope.row.status === 10">未报价</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column prop="name" header-align="center" align="center" label="询价人"></el-table-column>
      <el-table-column prop="createTime" header-align="center" align="center" label="询价时间" width="155px"></el-table-column>
      <el-table-column prop="remark" header-align="center" align="center" label="备注">
        <template slot-scope="scope">
          <el-tooltip class="item" placement="top">
            <div slot="content" class="tooltip-content">
              {{scope.row.remark}}
            </div>
            <div class="ellipsis" style="width: 100%;">{{scope.row.remark}}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="acceptFeedback" header-align="center" align="center" label="受理反馈">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="left" width="250">
            <p class="line-break back_content">{{ scope.row.acceptFeedback }}</p>
            <div slot="reference" class="line-break ellipsis">
              {{ scope.row.acceptFeedback }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-if="scope.row.status === '10'" @click="updateHandle(scope.row)">修改</el-button>
          <el-button type="text" size="small" @click="detailHandle(scope.row)">查看详细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="orderdataList"
      v-loading="dataLoading"
      key="orderTable"
      v-show="dataForm.status === '19'"
      border>
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无相关询价订单">
        <div>暂无相关询价订单</div>
      </div>
      <el-table-column type="index" header-align="center" align="center" width="50" label="No."></el-table-column>
      <!-- <el-table-column prop="id" header-align="center" align="center" label="id"></el-table-column> -->
      <el-table-column prop="inquiryOrderCode" header-align="center" align="center" label="订单号"></el-table-column>
      <el-table-column prop="inquiryStatus" header-align="center" align="center" label="状态" width="100px">
        <template slot-scope="scope">
          {{$getDictLabel('INQUIRY_ORDER_STATUS', scope.row.inquiryStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="userName" header-align="center" align="center" label="用户名" width="80px"></el-table-column>
      <el-table-column prop="userMobile" header-align="center" align="center" label="联系电话" width="110px"></el-table-column>
      <el-table-column prop="totalCount" header-align="center" align="center" label="询价商品" width="110px">
        <template slot-scope="scope">
          {{scope.row.totalCount}}个商品
        </template>
      </el-table-column>
      <el-table-column prop="userShopName" header-align="center" align="center" label="业务部门"></el-table-column>
      <!-- <el-table-column prop="inquiryTotalPrice" header-align="center" align="center" label="订单金额(元)"></el-table-column> -->
      <el-table-column prop="createTime" header-align="center" align="center" label="提交时间"></el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="detailOrderHandle(scope.row)">查看详细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="dataForm.page"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="dataForm.limit"
                   :total="total"
                   layout="total, sizes, prev, pager, next, jumper"
                   @size-change="pageSizeChangeHandle"
                   @current-change="getDataList">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'inquiryList', // 询价列表页
  data () {
    return {
      dataLoading: false,
      inquiryStatusList: [
        {
          key: '',
          lable: '全部'
        },
        {
          key: '10',
          lable: '报价中'
        },
        {
          key: '16,17,18,19',
          lable: '已报价'
        },
        {
          key: '19',
          lable: '已生成订单'
        }
      ],
      dataForm: {
        page: 1,
        limit: 10,
        startTime: null,
        endTime: null,
        status: '',
        inquiryNo: ''
      },
      total: 0,
      dataList: [],
      orderdataList: []
    }
  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    getDataList (val) {
      if (this.dataForm.status !== '19') {
        this.getInquriyDataList(1)
      } else {
        this.getOrderDataList(1)
      }
    },
    // 获取列表数据
    getInquriyDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      this.$http.post(`/front/consumer/inquirysheet/myList`, this.dataForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.count || 0
          this.dataList = res.data.data || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改当前询价单查询状态
    changeStatusHandle (valueKey) {
      if (this.dataLoading) {
        return false
      }
      if (valueKey === this.dataForm.status) {
        return false
      }
      this.dataForm.status = valueKey
      this.dataForm.orderCode = ''
      this.dataForm.startTime = null
      this.dataForm.endTime = null
      this.getDataList(1)
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(1)
    },
    // 查看详情
    detailHandle (row) {
      this.$router.push({
        name: 'inquiryDetail',
        query: {
          id: row.inquiryId
        }
      })
    },
    // 修改
    updateHandle (row) {
      this.$router.push({
        name: 'inquiryCreate',
        query: {
          id: row.inquiryId
        }
      })
    },
    // 新增询价单
    addHandle () {
      this.$router.push({
        name: 'inquiryCreate'
      })
    },
    // 催促受理
    urgeHandle () {
      this.$http.post(`/front/consumer/inquirysheet/userUrgeAcceptanceInquirySheet`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success('催促成功')
        })
    },
    // 获取询价订单列表数据
    getOrderDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      this.$http.post(`/front/consumer/inquirysheet/myInquiryOrderList`, this.dataForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.count || 0
          this.orderdataList = res.data.data || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 跳转询价订单详情
    detailOrderHandle (row) {
      if (row) {
        this.$router.push({
          name: 'inquiryOrderDetail',
          query: {
            id: row.inquiryOrderId
          }
        })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.inquiry_list{
  .title_row{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .inquiry-tab-item {
    display: inline-block;
    margin-left: 10px;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active{
    color: #1D65A8;
    border-bottom: 2px solid #1D65A8;
  }
  .tooltip-content{
    max-width: 500px;
    text-align: center;
    border-color:#fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .back_content{
    color: #fff;
    background: rgba(0,0,0,0.5);
  }
}
</style>
